<template>
    <div class="homepageItem" id="homepageItem" :style="{ 'padding': borderPadding + 'px'}">
        <div class="con" :style="{'width': width + 'px',
                            'height':height + 'px'}">
            <router-link v-if="msgData && !isExternalUrl" :to="{path: '/home/product/list/' + msgData.id}"
                         target="_blank">
                <div class="item"
                     :style="{'line-height': (height-(paddingLeft*2)) + 'px',
                                    'padding-top':paddingUp + 'px',
                                    'padding-bottom':paddingUp + 'px',
                                     'padding-left':paddingLeft + 'px',
                                     'padding-right':paddingLeft + 'px',
                                      'background-color': bgColor}">
                    <VueCssScale v-if="webCoverFileImg" position="" style="width: 100%;" className="newgreen"
                                 imgClass='width'
                                 :url="imgBaseUrl + webCoverFileImg.key">
                    </VueCssScale>

                    <div class="shoucang hover" v-if="isCollection" @click="collect($event)">
                        <i class="iconfont icon-collectstar"></i>
                        <span>收藏</span>
                    </div>

                    <div class="bottomText hover" v-if="isShowDetail">
                        <span class="left">{{msgData.category}}</span>
                        <span class="right" v-if="isCollection">
                                <i class="iconfont icon-collectstar1" @click="collect($event)"></i>
                                <span v-if="msgData.collectedNum">{{msgData.collectedNum}}</span>
                            </span>
                    </div>

                    <div class="bottomText hover designDetail" v-if="designShowDetail">
                        <span class="top">{{msgData.bigTitle}}</span><br/>
                        <span class="bottom">{{msgData.subTitle}}</span>
                    </div>

                </div>
                <div class="bottomTextCC" v-if="isbottomText">
                    <span v-if="msgData.subTitle">{{msgData.subTitle}}</span>
                </div>
            </router-link>

            <a v-if="msgData && isExternalUrl" :href="'/home/indexDetail/' + msgData.id" target="_blank">
                <div class="item"
                     :style="{'line-height': (height-(paddingLeft*2)) + 'px',
                                    'padding-top':paddingUp + 'px',
                                    'padding-bottom':paddingUp + 'px',
                                     'padding-left':paddingLeft + 'px',
                                     'padding-right':paddingLeft + 'px',
                                      'background-color': bgColor}">
                    <VueCssScale v-if="webCoverFileImg" position="" style="width: 100%;" className="newgreen"
                                 imgClass='width'
                                 :url="imgBaseUrl + webCoverFileImg.key">
                    </VueCssScale>

                    <div class="shoucang hover" v-if="isCollection" @click="collect($event)">
                        <i class="iconfont icon-collectstar"></i>
                        <span>收藏</span>
                    </div>

                    <div class="bottomText hover" v-if="isShowDetail">
                        <span class="left">{{msgData.category}}</span>
                        <span class="right" v-if="isCollection">
                                <i class="iconfont icon-collectstar1" @click="collect($event)"></i>
                                <span v-if="msgData.collectedNum">{{msgData.collectedNum}}</span>
                            </span>
                    </div>

                    <div class="bottomText hover designDetail" v-if="designShowDetail">
                        <span class="top">{{msgData.bigTitle}}</span><br/>
                        <span class="bottom">{{msgData.subTitle}}</span>
                    </div>

                </div>
                <div class="bottomTextCC" v-if="isbottomText">
                    <span v-if="msgData.bigTitle">{{msgData.bigTitle}}</span>
                </div>
            </a>


        </div>
    </div>
</template>
<style>
    #homepageItem .ivu-card-bordered {
        border: none;
    }

    #homepageItem a {
        display: inline-block;
        width: 100%;
        height: 100%;
    }
</style>

<style scoped>
    .homepageItem {
        vertical-align: top;
        display: inline-block;
        margin: -4px;
        background: #fff;
    }

    .homepageItem .con {
        background: #fff;
    }

    .main .item {
        margin-top: 0 !important;
    }

    .homepageItem .bottomTextCC {
        width: 100%;
        margin-top: 12px;
        text-align: left;
        padding-right: 60px;
    }

    .homepageItem .bottomTextCC span {
        font-size: 16px;
        color: #353838;
    }

    .homepageItem a {
        display: inline-block;
    }

    .homepageItem .item {
        width: 100%;
        height: 100%;
        display: inline-block;
        background: #EBEFF0;
        position: relative;
        text-align: center;
    }

    .homepageItem .item img {
        display: inline-block;
        vertical-align: middle;
    }

    .homepageItem .item .shoucang {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 64px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        color: #fff;
        background: #E14B5D;
        border-radius: 100px;
    }

    .homepageItem .item .shoucang:before {
        content: '';
        position: absolute;
        top: -20px;
        right: -20px;
        bottom: -20px;
        left: -20px;
    }

    .homepageItem .item .shoucang span, .homepageItem .item .shoucang i {
        font-size: 12px;
    }

    .homepageItem .item .bottomText {
        width: 100%;
        height: 40px;
        line-height: 40px;
        position: absolute;
        bottom: 0;
        left: 0;
        /*background-image: linear-gradient(180deg, rgba(108, 111, 112, 0.00) 3%, rgba(108, 111, 112, 0.13) 100%);*/
        background: rgba(162, 162, 168, 0.8);
        font-size: 16px;
        color: #ffffff;
        padding: 0 20px;
    }

    .homepageItem .item .designDetail {
        background: rgba(53, 56, 56, 0.8);
    }

    .homepageItem .item .bottomText .left {
        float: left;
        width: auto !important;
    }

    .homepageItem .item .bottomText .right {
        float: right;
    }

    .homepageItem .item .bottomText .right i {
        font-size: 12px;
    }

    .homepageItem .item .designDetail {
        height: 60px;
        color: #fff;
        text-align: left;
    }

    .homepageItem .item .designDetail .top {
        display: inline-block;
        width: 100%;
        font-size: 18px;
        color: #FFFFFF;
        float: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .homepageItem .item .designDetail .bottom {
        display: inline-block;
        width: 100%;
        font-size: 14px;
        color: #FFFFFF;
        float: left;
        margin-top: -19px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .homepageItem .item .hover {
        display: none;
    }

    .homepageItem .item:hover .hover {
        display: inline-block;
    }

    .newgreen {
        display: inline-block;
        position: relative;
        overflow: hidden;
    }

    .newgreen img {
        width: 100%;
        height: 100%;
    }

    .vue-css-scale {
        border: none;
    }
</style>

<script>
    import api from '../../api'
    import VueCssScale from './vue-css-scale';

    export default {
        props: {
            webCoverFileImg: {
                type: Object,
                default: {}
            },
            width: {
                type: Number,
                required: true
            },
            height: {
                type: Number,
                required: true
            },
            paddingUp: {
                type: Number,
                default: 0
            },
            paddingLeft: {
                type: Number,
                required: true
            },
            borderPadding: {
                type: Number,
                default: 0
            },
            bgColor: {
                type: String,
                default: '#EBEFF0'
            },
            isCollection: {
                type: Boolean,
                default: true
            },
            isShowDetail: {
                type: Boolean,
                default: true
            },
            isbottomText: {
                type: Boolean,
                default: false
            },
            designShowDetail: {
                type: Boolean,
                default: false
            },

            msgData: {
                type: Object
            },
            aspectRatio: {
                type: Number
            },
            urlType: {
                type: String,
                default: ''
            },
            isExternalUrl: {
                type: Boolean,
                default: false
            }

        },
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl,
                routerParams: {},
            };
        },
        methods: {
            collect(e) {
                e.preventDefault()
                this.$root.$children[0].$refs.collector.open(this.msgData, 'product');
            },
        },
        components: {
            VueCssScale
        },
        created() {
            ;
            if (this.urlType === 'myDesigndetails') {
                this.routerParams = {
                    id: this.msgData.id,
                    type: 0
                }
            } else {
                this.routerParams = {
                    id: this.msgData.id
                }
            }
        }
    };
</script>